import { render, staticRenderFns } from "./charge.vue?vue&type=template&id=357c8876&scoped=true&"
import script from "./charge.vue?vue&type=script&lang=js&"
export * from "./charge.vue?vue&type=script&lang=js&"
import style0 from "./charge.vue?vue&type=style&index=0&id=357c8876&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357c8876",
  null
  
)

export default component.exports